export default "__VITE_ASSET__CHBJ2GHf__"